import { ApiConnector } from '@/services/ApiConnector';
import { useState } from 'react';
import useUserDetails from './useUserDetails';

/**
 * useUploadFile Hook
 * Manages the state and operation for uploading the Snowflake PPR file.
 * Uses the provided URL and access token for the API request.
 *
 * @param {string} url - The base URL for the API
 * @param {string} accessToken - The access token for authorization
 */
const useUploadFile = (accessToken: string) => {
  const { gid } = useUserDetails();

  const uploadFile = async (file: File) => {
    const formData = new FormData();
    const now = new Date();
    const date = `${now.getDate().toString().padStart(2, '0')}${(now.getMonth() + 1)
      .toString()
      .padStart(2, '0')}${now.getFullYear().toString().slice(-2)}${now
      .getHours()
      .toString()
      .padStart(2, '0')}${now.getMinutes().toString().padStart(2, '0')}`;
    try {
      const urlInputFileResponse = await ApiConnector(
        'GET',
        `uploadfactory?date=${date}&gid=${gid}`,
        { baseUrl: import.meta.env.VITE_API_URL, accessToken: accessToken },
        { 'Content-Type': 'application/json', Accept: 'application/json' },
      );
      if (urlInputFileResponse.status !== 200) {
        throw new Error('Failed to get upload URL');
      }
      const { url, fields } = urlInputFileResponse.data;
      formData.append('key', fields['key']);
      formData.append('x-amz-algorithm', fields['x-amz-algorithm']);
      formData.append('x-amz-credential', fields['x-amz-credential']);
      formData.append('x-amz-date', fields['x-amz-date']);
      formData.append('x-amz-security-token', fields['x-amz-security-token']);
      formData.append('x-amz-signature', fields['x-amz-signature']);
      formData.append('policy', fields['policy']);
      formData.append('file', file);

      const response = await fetch(url, {
        method: 'POST',
        body: formData,
      });
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
    } catch (error) {
      console.error('File upload failed');
    }
  };

  return { uploadFile };
};

export default useUploadFile;
